<div class="container-fluid">

    <div class="row  d-flex justify-content-center">
        <div class="row justify-content-center align-items-center col-12 col-md-10 col-xl-8">

            <mat-form-field class="col-12 col-md-6 col-lg-4">
                <mat-select placeholder="Statut du chantier" [(ngModel)]="SelectedStatus" (selectionChange)="saveLastSelectedStatus()">
                    @for (status of StrategyStatusList; track status) {
                    <mat-option class="p-0 " [value]="status.idx">
                        <div class="row h-100">
                            <div class="col-1 h-100" style="width: 10px; text-indent: 20px;" [style.background]="getColorByInterventionStatus(status.idx)">
                            </div>
                            <div class="col-auto m-auto">
                                <div>{{status.s}} </div>
                            </div>
                        </div>
                    </mat-option>
                    }
                    <mat-option [value]="ALL">
                        <div class="row h-100">
                            <div style="width: 10px; text-indent: 20px;" class="col-1 m-auto">
                                <div> Tous </div>
                            </div>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-12 col-md-6 col-lg-4">
                <input matInput placeholder="Nom du chantier" [(ngModel)]="SearchText" (keyup.enter)="search()">
            </mat-form-field>

            <div class="col-auto">
                <mat-checkbox [(ngModel)]="HorsStrategy"> Hors stratégie </mat-checkbox>
            </div>

            <span class="col-auto d-none d-lg-inline">
                <button appPreventDoubleClick class="m-md-2" mat-mini-fab color="primary" (throttledClick)="search()">
                    <mat-icon class="material-symbols-outlined">search</mat-icon>
                </button>
                @if (OnlyFavorites) {
                <button appPreventDoubleClick mat-mini-fab color="primary" (throttledClick)="getFavoritesOnly()" [disabled]="">
                    <mat-icon class="material-symbols-outlined">star</mat-icon>
                </button>
                }
                @if (!OnlyFavorites) {
                <button appPreventDoubleClick mat-mini-fab color="primary" (throttledClick)="getFavoritesOnly()" [disabled]="">
                    <mat-icon class="material-symbols-outlined">star_border</mat-icon>
                </button>
                }
                <button appPreventDoubleClick class="col-8 m-md-2" mat-mini-fab color="accent" (throttledClick)="navigateToStrategy()" matTooltip="Nouveau chantier">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                </button>
                <button appPreventDoubleClick class="col-8 m-md-2" mat-mini-fab color="accent" (throttledClick)="openExportBox()" matTooltip="Demande d'export">
                    <mat-icon class="material-symbols-outlined">file_download</mat-icon>
                </button>

            </span>
            <!-- <div class="row justify-content-center" fxShow fxHide.lt-md>
    </div> -->

            <span class="col-12 d-lg-none">
                <button appPreventDoubleClick class="col-12" mat-raised-button color="primary" (throttledClick)="search()">
                    Rechercher
                </button>
                <button appPreventDoubleClick class="col-12 my-3" mat-raised-button color="primary" (throttledClick)="getFavoritesOnly()" [disabled]="">
                    <mat-icon class="material-symbols-outlined">star</mat-icon>
                </button>
                <button appPreventDoubleClick class="col-12" mat-raised-button color="accent" (throttledClick)="navigateToStrategy()">
                    Nouvelle demande de stratégie
                </button>
            </span>

        </div>
    </div>

    <div class="row justify-content-center my-5">
        @for (s of StrategyList; track s) {
        <div class="col-12 col-md-4 col-xl-2 m-1">
            <div class="card h-100 ">
                <h5 class="card-header">{{s.Portfolio.SamplingPoint.Name}}</h5>
                <!-- <h6 class="card-header">{{s.Portfolio.StrategyRequestDate | date}}</h6> -->
                <div class="card-body">
                    <!-- <h5 class="card-title">{{s.Portfolio.SamplingPoint.Code}}</h5> -->
                    <p class="card-text">{{s.Portfolio.SamplingPoint.Address}}</p>
                    <p class="card-text">{{s.Portfolio.SamplingPoint.ZipCode}} {{s.Portfolio.SamplingPoint.City}}</p>
                    <p class="card-text">Stratégie N°{{s.Id}}</p>
                </div>
                <div class="row d-flex justify-content-around no-gutters">
                    @if (s.IsFavorite) {
                    <button appPreventDoubleClick mat-icon-button color="primary" matTooltip="Retirer des favoris" (throttledClick)="toggleFavorite(s)" [disabled]="">
                        <mat-icon class="material-symbols-outlined">star</mat-icon>
                    </button>
                    }
                    @if (!s.IsFavorite) {
                    <button appPreventDoubleClick mat-icon-button color="primary" matTooltip="Ajouter aux favoris" (throttledClick)="toggleFavorite(s)" [disabled]="">
                        <mat-icon class="material-symbols-outlined">star_border</mat-icon>
                    </button>
                    }
                    <button appPreventDoubleClick mat-icon-button color="primary" matTooltip="Modifier la demande" (throttledClick)="navigateToStrategy(s)">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                    </button>
                    @if (s.Status >= EStrategyStatus.Proposal && s.Status !== EStrategyStatus.Ordered) {
                    <button appPreventDoubleClick mat-icon-button color="primary" matTooltip="Planifier des mesures"
                            (throttledClick)="navigateToPurchaseView(s)">
                        <mat-icon class="material-symbols-outlined">event</mat-icon>
                    </button>
                    }
                    @if (s.Status >= EStrategyStatus.Proposal && s.Status !== EStrategyStatus.Ordered) {
                    <button appPreventDoubleClick mat-icon-button color="primary"
                            matTooltip="Avancement de la stratégie" (throttledClick)="navigateToStrategyDetail(s)">
                        <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                    </button>
                    }
                    <!-- <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="cancelIntervention(i)">
          <mat-icon class="material-symbols-outlined">delete_outline</mat-icon>
        </button> -->
                </div>
                @if (!s.ContexteHorsStrategie) {
                <div class="mx-5" style="height: 5px;" [style.background]="getColorByInterventionStatus(s.Status)" [matTooltip]="getStrategyStatusName(s.Status)"></div>
                }
            </div>
        </div>
        }
    </div>
</div>